module.exports = __webpack_public_path__ + "static/media/logo.77f49518.PNG";